import * as db from './db'

/**
 * Кэш чтения чата.
 *
 * Водитель в туннеле должен суметь ПЕРЕЧИТАТЬ распоряжение — Slack
 * и Teams на этом ломаются, у них офлайн почти ничего не показывает.
 * Храним последнюю страницу каждого активного диалога; лента
 * рендерится из кэша мгновенно, сеть — фоновое обновление.
 *
 * Одна запись на диалог, а не сообщение-на-строку: чтение и запись
 * атомарны, а больше последней страницы офлайн и не нужно —
 * «отсутствовал дольше — перезагрузи» действует и здесь.
 */

export const CACHE_PAGE = 50
/** Сколько диалогов держим: активная переписка водителя — единицы. */
export const MAX_CONVERSATIONS = 20
export const MAX_AGE_DAYS = 30

export async function cacheMessages(conversationId, messages) {
  if (!conversationId) return null
  const record = {
    conversationId: String(conversationId),
    // Хвост ленты — последние сообщения важнее первых.
    items: (messages || []).slice(-CACHE_PAGE),
    updatedAt: new Date().toISOString(),
  }
  await db.put(db.STORE_MESSAGES, record)
  return record
}

export async function getCachedMessages(conversationId) {
  const record = await db.get(db.STORE_MESSAGES, String(conversationId))
  return record?.items || null
}

/**
 * Очистка кэша: старые и лишние диалоги.
 *
 * Кэш восстановим из сети — политика жёстче, чем у фото:
 * при переполнении просто выкидываем самые давние.
 */
export async function pruneCache({
  maxConversations = MAX_CONVERSATIONS,
  maxAgeDays = MAX_AGE_DAYS,
} = {}) {
  const all = (await db.getAll(db.STORE_MESSAGES)) || []
  if (all.length === 0) return { removed: 0 }

  const cutoff = Date.now() - maxAgeDays * 86_400_000
  const removed = all.filter((r) => new Date(r.updatedAt).getTime() < cutoff)

  let survivors = all.filter((r) => !removed.includes(r))
  if (survivors.length > maxConversations) {
    survivors = survivors.sort(
      (a, b) => new Date(a.updatedAt) - new Date(b.updatedAt)
    )
    removed.push(...survivors.slice(0, survivors.length - maxConversations))
  }

  await Promise.all(removed.map((r) => db.remove(db.STORE_MESSAGES, r.conversationId)))
  return { removed: removed.length }
}

export const clearConversation = (conversationId) =>
  db.remove(db.STORE_MESSAGES, String(conversationId))
